// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Resource from 'vue-resource'
import store from './store'
import App from './App'
// import 'bootstrap/dist/css/bootstrap.min.css'
import * as uiv from 'uiv'
import router from './router'
import user from './user'
import VueQrcode from '@xkeshi/vue-qrcode'
// import currency filter
import VueCurrencyFilter from 'vue-currency-filter'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
// import './sass/a'
// import './sass/app.sass'
import DisableAutocomplete from '@/libs/disable-autocomplete'
import socket from '@/socket.js'
import BootstrapVue from 'bootstrap-vue'
import VueBreadcrumbs from 'vue-breadcrumbs'
import Notifications from 'vue-notification'
// import 'core-js/es6/promise'
// import 'core-js/es6/string'
// import 'core-js/es7/array'
import '@coreui/coreui/js/src/index'

// import Vuikit from 'vuikit'

import Vuetable from 'vuetable-2/src/components/Vuetable.vue'
import VuetablePagination from './components/ui/vuetable-pagination.vue'
import VuetablePaginationDropdown from 'vuetable-2/src/components/VuetablePaginationDropdown.vue'
import Vuelidate from 'vuelidate'

import BsDialog from '@/components/ui/dialog'
import CKEditor from '@ckeditor/ckeditor5-vue'
import tinymce from 'vue-tinymce-editor'
import vueVimeoPlayer from 'vue-vimeo-player'

// hh
Vue.component('vuetable', Vuetable)
Vue.component('vuetable-pagination', VuetablePagination)
Vue.component('vuetable-pagination-dropdown', VuetablePaginationDropdown)

Vue.use(uiv)
Vue.use(Resource)
Vue.use(ElementUI)
Vue.use(BootstrapVue)
// Vue.use(Vuikit)
Vue.use(Vuelidate)
Vue.use(vueVimeoPlayer)
Vue.use(VueBreadcrumbs)
Vue.use(Notifications)
Vue.component(VueQrcode.name, VueQrcode)
Vue.use(BsDialog)
Vue.use(CKEditor)
Vue.component('tinymce', tinymce)
Vue.use(DisableAutocomplete)

Vue.use(VueCurrencyFilter,
	{
		symbol: '',
		thousandsSeparator: '.',
		fractionCount: 2,
		fractionSeparator: ',',
		symbolPosition: 'front',
		symbolSpacing: false
	})

Vue.config.productionTip = false

let allowRefresh = true
Vue.http.interceptors.push((request, next) => {
	if (store.state.userAuth !== null) {
		var accessToken = store.state.userAuth.access_token
		request.headers.set('Authorization', 'Bearer ' + accessToken)
	}
	next((response) => {
		if (allowRefresh && response.status === 401) {
			allowRefresh = false
			return user.refresh(request).then(result => {
				return Vue.http(request).then(data => {
					return data
				})
			}, () => {
				user.logout()
			})
		} else {
			allowRefresh = true
		}
	})
})

user.init()
socket.init()

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store: store,
	router: router,
	validations: {},
	components: { App },
	template: '<App/>',
	sockets: {
		connect: function () {
			console.log('socket connected')
			store.dispatch('notification/sync')
			store.dispatch('userModule/sync')
		},
		disconnect: function () {
			console.log('socket disconnected')
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js